(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-builder"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const initialBundle = window.bundles?.findIndex(bundle => bundle.selected)

  const modal = Vue.component('confirmation-modal', {
    template: '#bundle-builder-modal-template',
    delimiters: ['${', '}'],
    props: {
      copy: {
        type: String,
        default: 'Are you sure?',
      },
      confirmText: {
        type: String,
        default: 'Yes',
      },
      cancelText: {
        type: String,
        default: 'No',
      },
      accept: {
        type: Function,
      },
      cancel: {
        type: Function,
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onAccept(e) {
        this.accept(e)
      },
      onCancel(e) {
        this.cancel()
      },
    },
  })

  const mountBundleBuilder = () => {
    return new Vue({
      el: '#bundle-builder',
      delimiters: ['${', '}'],
      data: {
        bundles: window.bundles, // The list of pre-built bundles
        bundleOptions: window.bundleOptions, // The config for each bundle size and the items that can be added in each position
        selectedPosition: null, // The currently selected custom item selector in position X
        prebuiltSelectorOpen: false, // Is the list of pre-built bundles selector open?
        clickedEvent: null,
        builderSettings: builderSettings, // The settings for the bundle builder
        itemSettings: itemSettings, // The settings for the items in the bundle builder

        // Features for new design
        previewingItem: null,
        customLineFilter: null,
        customShapeFilter: null,
        customColorFilter: null,
        customSortChoices: [
          { value: 'line', label: 'Line', attr: 'product_line', direction: 'asc', mobile: true, method: 'sortByLine' },
          { value: 'shape', label: 'Shape', attr: 'product_shape', direction: 'asc', mobile: true, method: 'sortByAlpha' },
          { value: 'color', label: 'Color', attr: 'color_filter_title', direction: 'asc', mobile: false, method: 'sortByAlpha' },
        ],
        customSort: 'line',
        curatedLineFilter: null,
        curatedColorFilter: null,
        curatedSort: 'line',
        curatedSortChoices: [
          { value: 'line', label: 'Line', attr: 'product_line', direction: 'asc', method: 'sortByLine' },
          // { value: 'color', label: 'Color', attr: 'product_color', direction: 'asc' },
        ],

        // Generic state stuff below
        imageWidth: 500,
        imageHeight: 500,
        formQuantity: 1,
        adding: false,
        error: false,
        errorMessage: null,
        errorTimer: null,
        showFilters: false,
        loggedIn,
        b2b,
        favorites: [],
        favoritesAddUrl,
        favoritesStatus: null,
        favoritesTimeout: null,
        shuffleConfirmation: false,
        sizeConfirmation: false,
        isDesktop: null,
        registryUrl,
        registryAddUrl,
        registryStatus: null,
        registryTimeout: null,
        registryVisible: false,
        registries: [],
        shared: false,
        sharedTimeout: null,

        activeTab: 'description',
        tabs: [
          {
            id: 'description',
            title: 'DESCRIPTION',
            content: window.bundles[initialBundle]?.description,
          },
          {
            id: 'specs',
            title: 'SPECS',
            content: '',
          },
          {
            id: 'care',
            title: 'CARE',
            content: careInstructions
          },
          {
            id: 'shipping-returns',
            title: 'SHIPPING & RETURNS',
            content: shippingReturns
          }
        ],
      },
      filters: {
        money: function(price) {
          const value = (price / 100).toFixed(2).replace('.00', '')
          return `$${value}`
        },
        image: function(url, width, height) {
          const parts = url.split('.')
          parts[parts.length - 2] += `_${width}x${height}`
          return parts.join('.')
        },
        simpleTitle: function(str) {
          // @TODO Refactor this
          if(str.includes(' in ')) {
            return str.split(' in ')[0]
          }
          return str
        }
      },
      mounted: function() {
        this.preloadImages()
        this.setTabContent('specs', this.buildSpecs())
        // @TODO: The following was uncommented because it was changed to a modal
        // document.addEventListener('click', e => {
        //   this.selectPosition(null)
        //   this.showRegistries(false)
        // })
        mql = window.matchMedia(`(min-width: ${mobileBreakpoint}px)`)
        this.isDesktop = mql.matches
        mql.addEventListener('change', e => {
          this.isDesktop = e.matches
        })
        this.adaEvents()
        this.addToRegistryListener()
        this.fetchFavorites()
      },
      watch: {
        isDesktop: function(isit) {
          this.selectPosition(null)
        },
        // When the selected bundle changes update the related tab content
        selectedBundle: function(bundle) {
          this.setTabContent('description', bundle.description)
          this.setTabContent('specs', this.buildSpecs())

          // If there is no content in the selected bundle then show the first tab with content by default
          const active = this.tabs.find(tab => tab.id === this.activeTab)
          if(!active.content) {
            this.activeTab = this.tabs.find(tab => tab.content).id
          }
          if(this.formQuantity > this.maxQty) {
            this.formQuantity = this.maxQty
          }
          return bundle
        },
        // When an item is selected update the specs
        selectedItems: function() {
          this.setTabContent('specs', this.buildSpecs())
        },
        // When the form quantity changes make sure we have enough
        formQuantity: function(qty) {
          if(qty > this.maxQty) {
            this.formQuantity = this.maxQty
          }
        },
      },
      computed: {
        // The max quantity that can be purchased for a given bundle
        maxQty: function() {
          if(this.selectedBundle?.custom) {
            const qtys = this.selectedItems.filter(Boolean).map(item => item.max_qty)
            return Math.min.apply(Math, qtys)
          }
          return this.selectedBundle?.max_qty
        },
        // Have we populated all items in the selectedBundle's required quantity
        isBundleFull: function() {
          return this.selectedItemCount === this.selectedQuantity
        },
        isPreviewingItem: function() {
          return this.previewingItem !== null
        },
        // How many items have we selected
        selectedItemCount: function() {
          return Math.min(this.selectedQuantity,this.selectedBundle?.bundle_items.filter(Boolean).length)
        },
        // Array of the bundle sizes to select from
        quantities: function() {
          return this.bundleOptions.filter(option => option.purchaseable).map(option => {
            return {
              id: option.position,
              title: option.title.replace(' Set', '')
            }
          })
        },
        // The currently selected bundle
        selectedBundle: function() {
          const selected = this.bundles.find(bundle => bundle.selected)
          if (!selected) return null;
          if(selected.id !== selected.quantity) {
            this.updateUrl(selected)
          }
          return selected
        },
        // The currently selected bundle items, filling in empty ones that haven't been chosen for a custom bundle
        selectedItems: function() {
          const ret = [];
          const indexes = Array.from(Array(this.selectedQuantity).keys())
          return indexes.map(index => {
            const item = this.selectedBundle.bundle_items[index]
            return typeof item === 'undefined' ? null : item
          })
        },
        // The current selected quantity (size of the bundle. Ex: 5-piece-set)
        selectedQuantity: function() {
          if (!this.selectedBundle) {
            return 0;
          }
          return this.selectedBundle.quantity
        },
        // Bundles that match the selected quantity (bundle size)
        bundlesByQuantity: function() {
          return this.bundles.filter(bundle => bundle.quantity === this.selectedQuantity)
          return bundles.concat({
            id: this.selectedQuantity,
            quantity: this.selectedQuantity,
            title: `Custom ${this.selectedQuantity} Piece`,
            custom: true,
            handle: `custom-${this.selectedQuantity}-peice`
          })
        },
        filteredBundlesByQuantity: function() {
          const sort = this.curatedSortChoices.find(choice => choice.value === this.curatedSort)
          let bundles = this.bundlesByQuantity.filter(bundle => {
            if(bundle.custom || !bundle.available) {
              return false
            }
            if(this.curatedLineFilter && bundle.product_line !== this.curatedLineFilter) {
              return false
            }
            return true
          })
          if (sort?.method) bundles = this[sort.method](bundles, sort)
          if(sort.direction === 'desc') {
            bundles.reverse()
          }
          return bundles
        },
        curatedBundles: function() {
          return this.bundles.filter(bundle => bundle.quantity === this.selectedQuantity && !bundle.custom)
        },
        // Get the available products in the selectedPosition (ex: you can choose between products X/Y/Z for the 2nd item in the bundle)
        productsByPosition: function() {
          return this.getProductsByPosition(this.selectedPosition)
        },
        filteredProductsByPosition: function() {
          const sort = this.customSortChoices.find(choice => choice.value === this.customSort)
          let products = this.productsByPosition.filter(product => {
            if(this.customLineFilter && product.product_line !== this.customLineFilter) {
              return false
            }
            if(this.customShapeFilter && product.product_shape !== this.customShapeFilter) {
              return false
            }
            return true
          })
          products = this[sort.method](products, sort)
          if(sort.direction === 'desc') {
            products.reverse()
          }
          return products
        },
        // Get the available products in the selectedPosition that match the selected filters and sorting for custom bundle items
        filteredVariantsByPosition: function() {
          const sort = this.customSortChoices.find(choice => choice.value === this.customSort)
          let variants = []
          this.filteredProductsByPosition.forEach(product => {
            product.variants.forEach(variant => {
              if(!this.customColorFilter || variant?.color_filters?.includes(this.customColorFilter)) {
                const v = variant
                v.product = Object.assign({}, product)
                v.product.color_title = variant.color_title === 'Default Title' ? '' : variant.color_title
                v.product.color_filter_title = variant.color_filter_title
                variants.push(v)
              }
            })
          })
          variants = this[sort.method](variants, sort)
          if(sort.direction === 'desc') {
            variants.reverse()
          }
          return variants
        },
        curatedLinesByQuantity: function() {
          const lines = this.bundlesByQuantity
            .filter(bundle => !bundle.custom && bundle.available)
            .map(bundle => bundle.product_line)
            .filter(line => line)
          return [...new Set(lines)].sort()
        },
        // Get a unique list of product lines by the selected position to show in the UI as filters if there are multiple
        customLinesByPosition: function() {
          const lines = this.productsByPosition.map(product => product.product_line).filter(line => line)
          return [...new Set(lines)].sort()
        },
        // Get a unique list of colors by the selected position to show in the UI as filters if there are multiple
        customColorsByPosition: function() {
          const colors = []
          this.productsByPosition.forEach(product => {
            product.variants.forEach(variant => {
              if(variant.available && variant?.color_filters?.length > 0) {
                colors.push(...variant?.color_filters)
              }
            })
          })
          return [...new Set(colors.filter(color => color && color !== 'Default Title'))].sort()
        },
        customShapesByPosition: function() {
          const shapes = this.productsByPosition.map(product => product.product_shape).filter(shape => shape)
          return [...new Set(shapes)].sort()
        },
        // Actual id's of items in bundle
        bundleItemIDs: function() {
          return this.getBundleItemIDs(this.selectedBundle)
        },
        // Price of a custom bundle
        bundlePrice: function() {
          if(!this.isBundleFull) {
            return this.selectedBundle?.price
          }
          return this.calculatePrice('price')
        },
        bundleComparePrice: function() {
          return this.calculatePrice('compare_at_price')
        },
        bundleSavings: function() {
          const savings = this.calculatePrice('price') - this.calculatePrice('compare_at_price')
          return `SAVE ${(savings / (this.calculatePrice('price')) * 100).toFixed(0)}%`
        },
        customSortAttr: function() {
          return this.customSortChoices.find(choice => choice.value === this.customSort).attr
        },
        curatedSortAttr: function() {
          return this.curatedSortChoices.find(choice => choice.value === this.curatedSort).attr
        }
      },
      methods: {
        capitalize: function(str) {
          return str.charAt(0).toUpperCase() + str.slice(1)
        },
        childProductsImage: function(item) {
          let childImage = null;
          if (item.child_products && item.child_products?.length > 0) {
            const childProduct = item.child_products.find(child => child.variants.some(variant => variant.id === item.id))
            childImage = childProduct ? `${childProduct.featured_image}&width=960` : null
          }
          return childImage;
        },
        groupSize: function(filteredVariantsByPosition, customSortAttr, v) {
          return filteredVariantsByPosition.filter(variant => (variant.product?.[customSortAttr] ?? '') === (v ?? '')).length
        },
        groupSizeCurated: function(filteredBundlesByQuantity, curatedSortAttr, v) {
          return filteredBundlesByQuantity.filter(variant => (variant?.[curatedSortAttr] ?? '') === (v ?? '')).length
        },
        groupSizeMobile: function(filteredVariantsByPosition, customSortAttr, v) {
          return filteredVariantsByPosition.filter(product => {
            return product.variants.filter(variant => variant.product?.[customSortAttr] === v).length > 0
          }).length
        },
        focusTrap: function(el, focusElement) {
          this.setFocusTrap(el, focusElement, 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        },
        focusTrapFilters: function(el, focusElement) {
          this.setFocusTrap(el, focusElement, 'button, [href], input.active, select, textarea, [tabindex]:not([tabindex="-1"])')
        },
        // Keep Tab focus inside el. Replaces any trap already on el so listeners don't stack up each time a modal is opened
        setFocusTrap: function(el, focusElement, selector) {
          if (el._bundleBuilderFocusTrap) {
            el.removeEventListener('keydown', el._bundleBuilderFocusTrap)
          }

          el._bundleBuilderFocusTrap = (e) => {
            if (e.key !== 'Tab') return

            // Look up the focusable elements on each Tab since the modal contents change as filters and previews change
            const focusableElements = el.querySelectorAll(selector)
            const firstElement = focusableElements[0]
            const lastElement = focusableElements[focusableElements.length - 1]
            if (!firstElement) return

            if (e.shiftKey) { // Shift + Tab
              if (document.activeElement === firstElement || document.activeElement === focusElement) {
                e.preventDefault()
                lastElement.focus()
              }
            } else { // Tab
              if (document.activeElement === lastElement) {
                e.preventDefault()
                firstElement.focus()
              }
            }
          }
          el.addEventListener('keydown', el._bundleBuilderFocusTrap)
        },
        adaEvents: function() {
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
              if (this.prebuiltSelectorOpen) {
                this.prebuiltSelectorOpen = false
                if (window.matchMedia('(min-width: 1024px)').matches) {
                  this.$refs['modal-curated-open'].focus()
                } else {
                  this.$refs['modal-curated-open-mobile'].focus()
                }
                this.showFilters = false
              }
              if (this.selectedPosition !== null && this.clickedEvent.target) {
                this.clickedEvent.target.focus()
                this.clickedEvent = null
                this.selectedPosition = null
                this.showFilters = false
              }
              if (document.querySelector('[data-bundle-builder-modal]')) {
                document.querySelector('[data-bundle-builder-modal-close]').click()
                if (window.matchMedia('(min-width: 1024px)').matches) {
                  this.$refs['shuffle'].focus()
                } else {
                  this.$refs['shuffle-mobile'].focus()
                }
              }
            }
            if (e.key === 'Enter' && (e.target == this.$refs['modal-curated-close'] || e.target.matches('[data-modal-curated-select]'))) {
              setTimeout(() => {
                if (window.matchMedia('(min-width: 1024px)').matches) {
                  this.$refs['modal-curated-open'].focus()
                } else {
                  this.$refs['modal-curated-open-mobile'].focus()
                }
              }, 100)
            }
            if (e.key === 'Enter' && (e.target == this.$refs['modal-custom-close'] || e.target.matches('[data-modal-custom-select]'))) {
              setTimeout(() => {
                if (this.clickedEvent.target) {
                  this.clickedEvent.target.focus()
                  this.clickedEvent = null
                }
              }, 100)
            }
            if (e.key === 'Enter' && (e.target.matches('[data-bundle-builder-modal-close]') || e.target.matches('[data-bundle-builder-modal-select]'))) {
              setTimeout(() => {
                if (window.matchMedia('(min-width: 1024px)').matches) {
                  this.$refs['shuffle'].focus()
                } else {
                  this.$refs['shuffle-mobile'].focus()
                }
              }, 100)
            }
            if (e.key === 'Enter' && (e.target == this.$refs['modal-mobile-close'])) {
              setTimeout(() => {
                if (this.clickedEvent.target) {
                  this.clickedEvent.target.focus()
                  this.clickedEvent = null
                }
              }, 100)
            }
            if (e.key === 'Enter' && (e.target.matches('.mobile-swatch'))) {
              setTimeout(() => {
                const modal = this.$refs['modal-mobile']
                const focusElement = this.$refs['modal-mobile-focus']
                if (modal && focusElement) {
                  if (this.isPreviewingItem && this.previewingItem.available) {
                    this.focusTrap(modal, focusElement)
                  }
                }
              }, 100)
            }
            if (e.key === 'Enter' && e.target == this.$refs['modal-curated-filters-show']) {
              setTimeout(() => {
                const modal = this.$refs['modal-curated-filters']
                const focusElement = this.$refs['modal-curated-filters-focus']
                if (modal && focusElement) {
                  focusElement.focus()
                  this.focusTrapFilters(modal, focusElement)
                }
              }, 100)
            }
            if (e.key === 'Enter' && e.target == this.$refs['modal-curated-filters-close']) {
              setTimeout(() => {
                const modal = this.$refs['modal-curated']
                const focusElement = this.$refs['modal-curated-focus']
                if (modal && focusElement) {
                  focusElement.focus()
                  this.focusTrap(modal, focusElement)
                }
              }, 100)
            }
            if (e.key === 'Enter' && e.target == this.$refs['modal-mobile-filters-show']) {
              setTimeout(() => {
                const modal = this.$refs['modal-mobile-filters']
                const focusElement = this.$refs['modal-mobile-filters-focus']
                if (modal && focusElement) {
                  focusElement.focus()
                  this.focusTrapFilters(modal, focusElement)
                }
              }, 100)
            }
            if (e.key === 'Enter' && e.target == this.$refs['modal-mobile-filters-close']) {
              setTimeout(() => {
                const modal = this.$refs['modal-mobile']
                const focusElement = this.$refs['modal-mobile-focus']
                if (modal && focusElement) {
                  focusElement.focus()
                  this.focusTrap(modal, focusElement)
                }
              }, 100)
            }
          })
        },
        // Generate a background image style
        backgroundImage(colors) {
          if (!colors || colors?.length === 0) {
            return '';
          }
          if (colors?.length === 1) {
            return `background: ${colors[0]}`;
          }
          const gradient = colors.map((color, index) => {
            const start = (index / colors.length) * 100;
            const end = ((index + 1) / colors.length) * 100;
            return `${color} ${start}%, ${color} ${end}%`;
          }).join(', ');
          return `background: linear-gradient(90deg, ${gradient}); transform: rotate(45deg); transform-origin: center;`;
        },
        swatchColors: function(variant) {
          return this.backgroundImage(variant.colors);
        },
        // Calculate the bundle price or compare_at_price
        calculatePrice: function(field) {
          if(!this.selectedBundle?.custom) {
            return this.selectedBundle ? this.selectedBundle[field] : null
          }
          if(this.selectedBundle?.bundle_items?.length === 0) {
            return this.selectedBundle ? this.selectedBundle[field] : null
          }
          return this.selectedItems.reduce((prev, current) => prev + (current?.[field] || 0), 0)
        },
        // Generic link handler to make the selected bundle a custom one
        selectCustom: function() {
          this.selectCustomBundle()
        },
        // Generic link handler to make the selected bundle a pre-built bundle
        selectPrebuilt: function() {
          this.togglePrebuiltBundles(true)
        },
        // Set the sort for curated bundles
        selectCuratedSort: function(order) {
          this.curatedSort = order
        },
        // Set the sort for curated bundles
        selectCustomSort: function(order) {
          this.customSort = order
        },
        // Set the color filter for custom bundles
        selectCustomColorFilter: function(color) {
          this.customColorFilter = color ? color : null;
        },
        // Set the line filter for custom bundles
        selectCustomLineFilter: function(line) {
          this.customLineFilter = line ? line : null;
        },
        // Set the shape filter for custom bundles
        selectCustomShapeFilter: function(shape) {
          this.customShapeFilter = shape ? shape : null;
        },
        // Set the line filter for curated bundles
        selectCuratedLineFilter: function(line) {
          this.curatedLineFilter = line ? line : null;
        },
        // Show/hide the list of pre-build bundles to display
        togglePrebuiltBundles: function(direction) {
          if (direction === undefined) {
            this.prebuiltSelectorOpen = !this.prebuiltSelectorOpen
          } else {
            this.prebuiltSelectorOpen = direction
          }
          if (direction && this.prebuiltSelectorOpen) {
            this.$nextTick(() => {
              const modal = this.$refs['modal-curated']
              const focusElement = this.$refs['modal-curated-focus']
              if (modal && focusElement) {
                focusElement.focus()
                this.focusTrap(modal, focusElement)
              }
            })
          }
        },
        // Is there a selected item in position X
        hasProductInSelectedPosition: function(position) {
          return this.selectedBundle.bundle_items[position] ? true : false
        },
        // Preview a variant within a product
        previewVariant: function(variant, product = null) {
          const child_product = product || null;
          product = this.bundleOptions[this.selectedPosition].custom_items.find(p => p.variants.some(v => v.id === variant.id));
          variant = product.variants.find(v => v.id === variant.id);
          this.bundleOptions[this.selectedPosition].custom_items.forEach(p => p.previewing = false);

          if (child_product) {
            product.child_product = child_product;
            variant.featured_image = {};
            variant.featured_image.src = child_product.featured_image;
          }
          product.selected_variant = variant;
          this.previewingItem = variant;
          product.previewing = true;
        },
        applyPreview: function() {
          this.selectItem(this.previewingItem, this.selectedPosition)
          this.previewingProduct = null
        },
        updateSections: function(bundle) {
          fetch(`/products/${bundle.handle}?view=bundle-builder`)
            .then(res => res.text())
            .then((responseText) => {
              const doc = new DOMParser().parseFromString(responseText, 'text/html')
              const main = document.querySelector('main#main')
              document.title = doc.title
              for (const section of main.children) {
                if (!section.matches('.shopify-section--bundle-builder') && !section.querySelector('recently-viewed')) {
                  const id = section.id
                  const docSection = doc.getElementById(id);
                  section.innerHTML = docSection.innerHTML
                }
              }
              requestAnimationFrame(() => {
                window.inView();
                window.swipers();
              });
            })
            .catch((e) => {
              console.error(e);
            });
        },
        // Mark a specific bundle as being selected
        selectBundle: function(bundle) {
          let existingItems = [...this.selectedBundle.bundle_items]
          const changingToCustom = bundle.custom // && !this.selectedBundle.custom
          this.bundles.find(b => b.selected).selected = false
          this.bundles.find(b => b.id === bundle.id).selected = true
          if(changingToCustom) {
            // if(this.selectedBundle.bundle_items?.length === 0) {
            this.selectedBundle.bundle_items = existingItems
            // }
            this.selectedBundle.price = this.bundlePrice
          } else {
            // Don't close product selector when switching to custom bundle
            this.selectPosition(null)
          }
          this.togglePrebuiltBundles(false)
          this.curatedColorFilter = null
          this.curatedLineFilter = null
          this.updateSections(bundle)
        },
        // Select a prebuilt bundle from the pre-built UI so we can scroll back after selection
        selectPrebuiltBundle: function(bundle) {
          this.selectBundle(bundle)
          mql = window.matchMedia('(min-width: 1025px)')
          if(!mql.matches) {
            this.$nextTick(() => {
              document.getElementById('bundle-builder').scrollIntoView({inline: 'start', block: 'start', behavior: 'instant'})
            })
          }
        },
        // Select a custom bundle based on the selectedQuantity (size of the bundle)
        selectCustomBundle: function() {
          // Select the bundle where the id is the same as the quantity as these are the custom ones
          this.selectBundle(this.bundles.find(b => b.custom && b.quantity === this.selectedQuantity))
        },
        // Mark a specific quantity as being selected (ex: show bundles with 3 items)
        selectQuantity: function(quantity) {
          if(quantity.id === this.selectedQuantity) {
            return
          }
          const closestBundle = this.findClosestBundle(quantity.id)
          this.selectBundle(closestBundle)
        },
        // Find the bundle that closest matches the current bundle
        findClosestBundle: function(newQuantity) {
          const bundles = this.findBundlesByQuantity(newQuantity)
          const matchQuantity = Math.min(newQuantity, this.selectedQuantity)
          const currentBundleIDs = this.bundleItemIDs
          const indexes = Array.from(Array(matchQuantity).keys())
          const newBundle = bundles.find(bundle => {
            return indexes.every(index => {
              const length = index + 1
              if(bundle.bundle_items?.length < length || currentBundleIDs?.length < length) {
                return false
              }
              return bundle.bundle_items[index]?.id === currentBundleIDs[index]
            })
          })
          if(newBundle) {
            return newBundle
          }
          // @TODO: Add logic here to show empty values for the selected custom bundle
          if(this.selectedBundle.custom && newQuantity < this.selectedQuantity) {
            const newCustomBundle = bundles.find(bundle => bundle.custom)
            if(newCustomBundle) {
              newCustomBundle.bundle_items = this.selectedBundle.bundle_items.slice(0, matchQuantity)
              return newCustomBundle
            }
          }
          if(this.selectedBundle.custom) {
            const newCustomSize = this.bundles.find(b => b.custom && b.quantity === newQuantity)
            if(newCustomSize) {
              return newCustomSize
            }
          }
          return bundles[0]
        },
        // Show the available items to choose from for a given position. Ex: What items can be selected for the 2nd item in the bundle
        selectPosition: function(position) {
          this.selectedPosition = position
          this.customSort = this.itemSettings?.[position]?.default_sort || 'line'
          this.previewingItem = null
          if (position === null) {
            this.customColorFilter = null
            this.customLineFilter = null
            this.customShapeFilter = null
          }
          this.$nextTick(() => {
            const active = this.$refs?.choices?.find(item => item.matches('.active'))
            if (active) {
              active.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'})
            }
            this.$nextTick(() => {
              const modal = window.matchMedia('(min-width: 1024px)').matches ? this.$refs['modal-custom'] : this.$refs['modal-mobile']
              const focusElement = window.matchMedia('(min-width: 1024px)').matches ? this.$refs['modal-custom-focus'] : this.$refs['modal-mobile-focus']
              if (position !== null && modal && focusElement) {
                focusElement.focus()
                this.focusTrap(modal, focusElement)
              }
            })
          })
        },
        // When a different variant item is selected to create a custom bundle
        selectItem: function(item, position) {
          if(!item.available) {
            return
          }
          if(!this.selectedBundle.custom) {
            this.selectCustomBundle()
          }
          if(position === undefined) {
            position = this.selectedPosition
          }
          this.previewingItem = null
          Vue.set(this.selectedBundle.bundle_items, position, item)
          if(this.selectedBundle.custom) {
            const existingBundle = this.bundles.find(b => !b.custom && b.quantity === this.selectedBundle.quantity && this.getBundleItemIDs(b).join() === this.bundleItemIDs.join())
            if(existingBundle) {
              this.selectBundle(existingBundle)
            }
          }
          this.selectPosition(null)
        },
        // Get the availbale bundles based on quantity. Ex: show all bundles that have 5 items
        findBundlesByQuantity: function(qty) {
          return this.bundles.filter(b => b.quantity === qty)
        },
        // Get the available products that can be used for a given position in the bundle
        getProductsByPosition: function(position) {
          return this.bundleOptions[position].custom_items
        },
        // Get the list of item ids by bundle
        getBundleItemIDs: function(bundle) {
          return bundle.bundle_items.map(b => b?.id)
        },
        // Get the selected variant if one exists
        getSelectedVariant: function(product) {
          return product.variants.find(v => this.isItemInBundle(v))
        },
        // Change the url to the currently selected bundle
        updateUrl: function(selected) {
          const path = location.pathname.split('/products/')
          path[1] = selected.handle
          const params = new URLSearchParams(location.search)
          if(selected.custom) {
            selected.bundle_items.forEach((item, index) => {
              if(item) {
                params.set(`piece${index + 1}`, item.id)
              }
            })
          } else {
            params.delete('piece1')
            params.delete('piece2')
            params.delete('piece3')
            params.delete('piece4')
            params.delete('piece5')
          }
          params.sort()
          const url = path.join('/products/') + '?' + params.toString()
          history.replaceState(null, null, url)
        },
        // Is this product in the currently selected bundle
        isProductInBundle: function(product) {
          return product.variants.some(v => this.bundleItemIDs.includes(v.id))
        },
        // Is this product in the bundle in the specified position
        isProductInPosition: function(product, position) {
          return product.variants.some(v => v.id === this.bundleItemIDs[position])
        },
        // Is this item in the currently selected bundle
        isItemInBundle: function(item) {
          return this.bundleItemIDs.includes(item.id)
        },
        isItemInPosition: function(item, position) {
          return this.bundleItemIDs[position] === item.id
        },
        // Generate a random string
        randomString: function() {
          return (Math.random() + 1).toString(36).substring(2);
        },
        showError: function(error) {
          this.error = true
          this.errorMessage = error
          clearTimeout(this.errorTimer)
          this.errorTimer = setTimeout(() => {
            this.error = false
          }, 5000)
        },
        // Are all items available
        itemsAvailable: function() {
          if(this.selectedBundle) {
            return this.selectedItems.every(item => item?.available !== false)
          }
          return true
        },
        // Add to cart handler
        addToCart: function() {
          if(!this.isBundleFull) {
            this.showError('Please select all items first')
            return false
          }
          const bundleCode = this.randomString()
          this.adding = true
          this.error = false
          const items = []
          if(this.selectedBundle.custom) {
            // Items beyond the bundle size are kept so they return if the customer picks a larger size again,
            // so only add the items that fit in the selected size
            this.selectedItems.forEach((item, position) => {
              if(!item) {
                return
              }
              items.push({
                id: item.id,
                quantity: this.formQuantity,
                properties: {
                  _bundle_id: bundleCode,
                  _bundle_title: this.selectedBundle.title,
                  _bundle_parent: this.selectedBundle.variants[0].id,
                  _bundle_size: this.selectedQuantity,
                  _bundle_image: this.selectedBundle.featured_image,
                }
              })
            })
          } else {
            items.push({
              id: this.selectedBundle.variants[0].id,
              quantity: this.formQuantity,
              properties: {
                _bundle_title: this.selectedBundle.title,
                _bundle_size: this.selectedQuantity,
              }
            })
          }

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
          const formData = new FormData()
          items.reverse().forEach((item, index) => {
            Object.keys(item).forEach(key => {
              if (key === 'properties') {
                Object.keys(item.properties).forEach(propKey => {
                  formData.append(`items[${index}][properties][${propKey}]`, item.properties[propKey])
                })
              } else {
                formData.append(`items[${index}][${key}]`, item[key])
              }
            })
          })
          formData.append('sections', cart ? cart.getSectionsToRender().map(section => section.id) : [])
          formData.append('sections_url', window.location.pathname)
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json',
            },
            body: formData,
          }
          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(data => {
              this.adding = false
              this.error = false
              this.formQuantity = 1
              if (cart) {
                cart.renderContents(data);
              } else {
                window.location.href = routes.cart_url
              }
            })
            .catch(error => {
              console.error('HC-bb ERROR!', error)
              this.adding = false
              this.showError('Something went wrong, please try again')
            })
        },
        // Did every request in a Promise.allSettled result succeed
        allRequestsSucceeded: function(results) {
          return results.every(result => result.status === 'fulfilled' && result.value.ok)
        },
        showLoginModal: function() {
          MicroModal.show('add-to-registry-modal')
        },
        fetchFavorites: function() {
          // Favorites belong to a customer, so there is nothing to fetch when logged out
          if (!this.loggedIn) {
            return
          }
          const ignoredStates = ['Archived']
          const params = { per_page: 50 }
          const query = new URLSearchParams(params).toString()

          fetch(`${favoritesAddUrl}&${query}`)
            .then(res => res.text())
            .then((response) => {
              const data = JSON.parse(response);
              this.favorites = data.favorites.filter(favorite => {
                if (ignoredStates.includes(favorite.product.metafields.product_state)) {
                  return false
                }
                if (ignoredStates.includes(favorite.variant.metafields.variant_state)) {
                  return false
                }
                return true
              })
            })
            .catch((error) => {
              console.log(error);
            })
        },
        addToFavorites: function() {
          if (!this.loggedIn) {
            return this.showLoginModal()
          }
          if (!this.isBundleFull) {
            return this.showError('Please select all the items first')
          }
          let items
          if (this.selectedBundle.custom) {
            items = this.selectedItems.map(item => {
              if (!item) {
                return false
              }
              return {product_id: item.product_id, variant_id: item.id, shop: permanentDomain}
            }).filter(Boolean)
          } else {
            items = [{product_id: this.selectedBundle.id, variant_id: this.selectedBundle.variants[0].id, shop: permanentDomain}]
          }
          const exists = this.favorites.filter(favorite => favorite.variant_id == this.selectedBundle.variants[0].id && favorite.product_id == this.selectedBundle.id)
          if (exists.length) {
            this.favoritesStatus = 'added'
            this.favoritesTimeout = setTimeout(() => {
              this.favoritesStatus = null
            }, 2500)
            return
          }
          this.favoritesStatus = 'adding'
          const promises = items.map(item => {
            return fetch(this.favoritesAddUrl, {
              method: 'POST',
              body: JSON.stringify(item),
              headers: {
                'Content-Type': 'application/json'
              }
            })
          })
          clearTimeout(this.favoritesTimeout)
          Promise.allSettled(promises).then(results => {
            if (!this.allRequestsSucceeded(results)) {
              this.favoritesStatus = 'error'
            } else {
              this.favoritesStatus = 'added'
              this.fetchFavorites()
            }
            this.favoritesTimeout = setTimeout(() => {
              this.favoritesStatus = null
            }, 2500)
          })
        },
        share: async function() {
          try {
            await navigator.clipboard.writeText(window.location.href);
            console.log('Text successfully copied to clipboard');
            this.shared = true;
            clearTimeout(this.sharedTimeout);
            this.sharedTimeout = setTimeout(() => {
              this.shared = false;
            }, 2500);
          } catch (err) {
            console.error('Failed to copy text: ', err);
          }
        },
        showRegistries: async function(direction) {
          if (direction !== false) {
            if (!this.loggedIn) {
              return this.showLoginModal()
            }
          }
          if (direction !== false && !this.isBundleFull) {
            this.registryVisible = false
            return this.showError('Please select all the items first')
          }
          if (direction === true || direction === false) {
            this.registryVisible = direction
          } else {
            this.registryVisible = !this.registryVisible
          }
          if (!this.registryVisible) {
            return
          }
          if (this.registries?.length === 0) {
            this.registryStatus = 'loading'
            const request = await fetch(this.registryUrl)
            const data = await request.json()
            data.registries.forEach(registry => registry.selected = false)
            this.registries = data.registries
            this.registryStatus = null
          }
          this.registries.forEach(registry => registry.selected = false)
          this.registryVisible = true

          const container = document.querySelector('[data-product-registry-modal-registries]')
          let html = ''
          this.registries.forEach(registry => {
            const checked = registry.items.find(item => item.variant_id == this.selectedBundle.variants[0].id) ? ' checked="checked"' : ''
            html += `
              <li>
                <input type="checkbox" name="registry-name" id="registry-${registry.id}" value="${registry.id}"${checked} />
                <label for="registry-${registry.id}">
                  <span class="form-group__checkbox">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="11" height="9" viewBox="0 0 11 9" fill="none">
                      <path d="M9 2L4.1875 7L2 4.72727" stroke="white" stroke-width="1.5" stroke-linecap="square"></path>
                    </svg>
                  </span>
                  <span class="form-group__checkbox-label">${registry.name}</span>
                </label>
              </li>
            `
          })
          container.innerHTML = html

          return this.showLoginModal()
        },
        toggleRegistry: function(registry) {
          registry.selected = !registry.selected
        },
        addToRegistryListener: function() {
          document.addEventListener('click', (e) => {
            if (e.target.matches('[data-apply]')) {
              e.preventDefault()
              const checked = document.querySelectorAll('[name="registry-name"]:checked')
              checked.forEach(input => {
                const registryId = input.value
                const registry = this.registries.find(r => r.id == registryId)
                const exists = registry.items.find(item => item.variant_id == this.selectedBundle.variants[0].id)
                if (exists) return
                registry.selected = true
              })
              this.addToRegistry()
            }
          })
        },
        addToRegistry: function() {
          if (!this.isBundleFull) {
            return this.showError('Please select all the items first')
          }
          const registries = this.registries.filter(registry => registry.selected)
          let items
          if (this.selectedBundle.custom) {
            items = this.selectedItems.map(item => {
              if (!item) {
                return
              }
              return {product_id: item.product_id, variant_id: item.id, shop: permanentDomain, quantity: this.formQuantity}
            }).filter(Boolean)
          } else {
            items = [{product_id: this.selectedBundle.id, variant_id: this.selectedBundle.variants[0].id, shop: permanentDomain, quantity: this.formQuantity}]
          }

          const success = document.querySelector('[data-product-registry-modal-success]')
          const successLink = document.querySelector('[data-product-registry-modal-success-link]');
          const modalTitle = registries.length === 1 ? registries[0].name : 'your registries'
          const modalUrl = registries.length === 1 ? registries[0].manage_url : '/apps/registry/manage'
          success.innerHTML = `You've successfully added <strong>${this.formQuantity} x ${this.selectedBundle.title}</strong> to <a href="${modalUrl}">${modalTitle}</a>.`
          successLink.href = modalUrl

          this.registryStatus = 'adding'
          const promises = [];
          registries.forEach(registry => {
            const url = this.registryAddUrl.replace('REGISTRY_ID', registry.id)
            items.forEach(item => {
              promises.push(fetch(url, {
                method: 'POST',
                body: JSON.stringify(item),
                headers: {
                  'Content-Type': 'application/json'
                }
              }))
            })
          })
          clearTimeout(this.registryTimeout)
          Promise.allSettled(promises).then(results => {
            if (!this.allRequestsSucceeded(results)) {
              this.registryStatus = null
              MicroModal.close('add-to-registry-modal')
              setTimeout(() => {
                alert('There was a problem adding to registry')
              }, 100)
            } else {
              this.registryStatus = 'added'
              MicroModal.close('add-to-registry-modal')
              MicroModal.show('add-to-registry-modal-success')
              document.querySelector('[data-product-registry-modal-registries-form]').reset()
            }
            this.registryTimeout = setTimeout(() => {
              this.registryStatus = null
            }, 2500)
          })
        },
        getActiveVariantCount: function(product) {
          return product.variants.length
        },
        buildSpecs: function() {
          if (!this.selectedBundle) {
            return null
          }

          const specs = this.selectedBundle.bundle_items.map((item, index) => {
            if (!item) {
              return
            }
            // Only show specs for the active quantity
            if ((index + 1) > this.selectedQuantity) {
              return
            }
            const specs = []
            if (item.product_material) {
              specs.push(`
                <li><p class="font-regular font-size"
                  style="
                    --font-size-desktop: 14px;
                    --font-size-mobile: 13px;
                    line-height: 1.3;
                  ">${item.product_material}</p>
                </li>
              `)
            }
            if (item.product_height) {
              specs.push(`
                <li><p class="font-regular font-size"
                  style="
                    --font-size-desktop: 14px;
                    --font-size-mobile: 13px;
                    line-height: 1.3;
                  ">Height: ${Number(item.product_height)}"</p>
                </li>
              `)
            }
            if (item.product_diameter) {
              specs.push(`
                <li><p class="font-regular font-size"
                  style="
                    --font-size-desktop: 14px;
                    --font-size-mobile: 13px;
                    line-height: 1.3;
                  ">Diameter: ${Number(item.product_diameter)}"</p>
                </li>
              `)
            }
            if (item.product_capacity) {
              specs.push(`
                <li><p class="font-regular font-size"
                  style="
                    --font-size-desktop: 14px;
                    --font-size-mobile: 13px;
                    line-height: 1.3;
                  ">Capacity: ${Number(item.product_capacity)} fluid oz</p>
                </li>
              `)
            }
            if (specs.length > 0) {
              return {
                title: item.product_title,
                specs: specs.join('')
              }
            }
          }).filter(Boolean)
          if (specs.length > 0) {
            const markup = specs.map((spec, index) => {
              return `
                <h3 class="color font-family"
                  style="
                    --color-desktop: #9a8d81;
                    --color-mobile: var(--brown-04);
                    --font-faimly-desktop: var(--font-body);
                    --font-faimly-mobile: var(--font-bold);
                    font-size: 13px;
                    letter-spacing: 1%;
                  ">Piece ${index + 1}<span class="display"
                    style="
                      --display-desktop: none;
                      --display-mobile: inline;
                    ">:</span>
                </h3>
                <ul style="
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  margin-top: 7px;
                ">${spec.specs}</ul>
              `
            }).join('</li><li style="width: 50%;">')
            return `
              <ul class="product-care__specs-inner row-gap"
                style="
                  --row-gap-desktop: 80px;
                  --row-gap-mobile: 40px;
                  display: flex;
                  flex-flow: row wrap;
                ">
                <li style="width: 50%;">${markup}</li>
              </ul>
            `
          } else {
            return null
          }
        },
        // Set the content of a tab by it's tab id
        setTabContent: function(id, content) {
          const index = this.tabs.findIndex(tab => tab.id === id)
          if(index >= 0) {
            const tab = this.tabs[index]
            tab.content = content
            Vue.set(this.tabs, index, tab)
          }
        },
        // Pre load the bundle images to make them swap quicker. Piece option images are not preloaded since there
        // can be hundreds of them and they load when their picker is opened
        preloadImages: function() {
          const thumbs = []
          const images = []
          this.bundles.forEach(bundle => {
            thumbs.push(bundle.featured_image)
            images.push(bundle.featured_image)
            bundle.bundle_items.forEach(item => {
              if(item.featured_image && item.featured_image.src) {
                thumbs.push(item.featured_image.src)
              }
            })
          })

          thumbs.forEach(img => {
            if(img) {
              const image = new Image()
              image.src = this.$options.filters.image(img, this.imageWidth, this.imageHeight)
            }
          })
          images.forEach(img => {
            if(img) {
              const image = new Image()
              image.src = this.$options.filters.image(img, 350, 350)
            }
          })
        },
        updateQty(str) {
          if (str == 'decrease') {
            if (this.formQuantity > 1) {
              this.formQuantity--
            }
          }
          if (str == 'increase') {
            if(this.formQuantity < this.maxQty) {
              this.formQuantity++
            } else {
              this.showError(`There are only ${this.maxQty} available`)
            }
          }
        },
        // Format the product line
        productLine: function(item) {
          if(item?.product_line) {
            if(item.product_line.toLowerCase() === 'all') {
              return `All Lines`
            }
            return `${item.product_line} Line`
          }
          return null
        },
        colorTitle: function(variant) {
          if(variant.color_title && variant.color_title !== 'Default Title') {
            return variant.color_title
          }
        },
        showModal: function(id) {
          this.$set(this, id, true)

          let timer = setInterval(() => {
            // Because $refs are never available in the DOM... Good Vue
            const modal = document.querySelector('[data-bundle-builder-modal]')
            const focusElement = document.querySelector('[data-bundle-builder-modal-focus]')
            if (modal && focusElement) {
              focusElement.focus()
              this.focusTrap(modal, focusElement)
              clearInterval(timer);
            }
          }, 30)
        },
        // Select a random assortment of items
        shuffle: function() {
          this.selectCustomBundle();
          [...Array(this.selectedQuantity).keys()].forEach(position => {
            const products = this.getProductsByPosition(position)
            const randomProduct = products[Math.floor(Math.random() * products.length)]
            if(randomProduct) {
              const randomVariant = randomProduct.variants[Math.floor(Math.random() * randomProduct.variants.length)]
              if(randomVariant) {
                this.selectItem(randomVariant, position)
              }
            }
          })
          this.shuffleConfirmation = false
        },
        sortByAlpha: function(arr, options) {
          const b = arr.map(x => x?.[options.attr])
          return arr.sort((a, b) => {
            const aVal = a[options.attr] || 'zzzzz'
            const bVal = b[options.attr] || 'zzzzz'
            return aVal.localeCompare(bVal)
          })
        },
        sortByLine: function(arr, options) {
          const lineOrder = this.builderSettings?.product_line_sequence?.split('\n')?.map(line => line.trim())?.filter(Boolean) || []
          return arr.sort((a, b) => {
            const aVal = a[options.attr] || 'zzzzz'
            const bVal = b[options.attr] || 'zzzzz'
            let indexA = lineOrder.indexOf(aVal)
            let indexB = lineOrder.indexOf(bVal)
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
            return aVal.localeCompare(bVal)
          })
        }
      }
    })
  }
  var bb = mountBundleBuilder()
  window.bb = bb
  window.bundleBuilderMounted?.()
  document.addEventListener('shopify:section:load', mountBundleBuilder)
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    window.shareOnFacebook = ({ url = null, title = null, description = null } = {}) => {
    url = typeof url !== 'undefined' && url !== null ? url : window.location.href;
    title = typeof title !== 'undefined' && title !== null ? title : document.title;
    description = typeof description !== 'undefined' && description !== null ? description : '';
    if (typeof(FB) === "undefined" || !window.fbAsyncInit || !window.fbAsyncInit.hasRun) {
      window.open(
        'http://www.facebook.com/sharer.php?s=100&p[url]=' + encodeURIComponent(url) + '&p[title]=' + encodeURIComponent(title) + '&p[summary]=' + encodeURIComponent(description),
        'facebook-share-dialog',
        'width=626,height=436'
      );
    } else {
      FB.ui({ method: 'share', href: url });
    }
    return false;
  }

  window.shareOnPinterest = ({ url = null, title = null } = {}) => {
    url = typeof url !== 'undefined' && url !== null ? url : window.location.href;
    title = typeof title !== 'undefined' && title !== null ? title : document.title;
    window.open(
      '//www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + encodeURIComponent(title),
      'pinterest-share-dialog',
      'width=626,height=436'
    );
    return false;
  }

  // // Load Facebook SDK
  // window.fbAsyncInit = function() {
  //   FB.init({
  //     appId : 'YOUR_FACEBOOK_APP_ID',
  //     xfbml : true,
  //     version : 'v19.0' // or current version
  //   });
  // };

  // function shareOnFacebook() {
  //   FB.ui({
  //     method: 'share',
  //     href: 'https://yourwebsite.com',
  //   }, function(response) {
  //     // Callback logic if needed (e.g., alert on successful share)
  //   });
  // }
  } catch(e) { console.error(e); }
})();

})();
